<div *ngIf="!loading">
  <div class="d-flex justify-content-center">
    <div ngbTooltip="{{'lang.globals.countVisitors' | translate}}" container="body">
        <span *ngIf="editMode !== 1">
        {{trackerValueElement.count ? trackerValueElement.count : '-' }}
        </span>
      <input *ngIf="editMode === 1" style="width: 100px"
             type="number" class="form-control text-end" placeholder="..."
             [ngModel]="count" max="1000000" min="0"
             (ngModelChange)="countChange($event)">
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <div ngbTooltip="{{'lang.globals.uniqueVisitors' | translate}}" container="body">
         <span *ngIf="editMode !== 1">
        {{trackerValueElement.unique ? trackerValueElement.unique : '-'}}
         </span>
      <input *ngIf="editMode === 1" style="width: 100px" type="number" class="form-control text-end" placeholder="..."
             [ngModel]="unique" max="1000000" min="0"
             (ngModelChange)="uniqueChange($event)">
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <div ngbTooltip="{{'lang.globals.dwellTime' | translate}}" container="body">
         <span *ngIf="editMode !== 1">
        {{trackerValueElement.dwellTime ? trackerValueElement.dwellTime : '-'}}
         </span>
      <input *ngIf="editMode === 1" style="width: 100px" type="number" class="form-control text-end" placeholder="..."
             [ngModel]="dwellTime" max="1000000" min="0"
             (ngModelChange)="dwellTimeChange($event)">
    </div>
  </div>
</div>
